import { render, staticRenderFns } from "./addAVMember.vue?vue&type=template&id=58363529&scoped=true&"
import script from "./addAVMember.vue?vue&type=script&lang=js&"
export * from "./addAVMember.vue?vue&type=script&lang=js&"
import style0 from "./addAVMember.vue?vue&type=style&index=0&id=58363529&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58363529",
  null
  
)

export default component.exports